import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col space-y-5" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between pt-3" }
const _hoisted_3 = { class: "flex flex-row items-center space-x-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Provider Details ")
const _hoisted_5 = { class: "flex flex-row space-x-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Add transaction ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Change to Client")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Update Provider ")
const _hoisted_9 = { class: "w-full flex flex-col space-y-3" }
const _hoisted_10 = { class: "w-full flex flex-row items-start justify-start" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Identity verification ")
const _hoisted_12 = { class: "w-full grid mdlg:!grid-cols-4 gap-2 md:grid-cols-2 grid-cols-1" }
const _hoisted_13 = {
  key: 0,
  class: "col-span-1 rounded-md border-[1px] border-grey300 px-4 py-4 space-y-3 flex flex-col items-center justify-between"
}
const _hoisted_14 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_15 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Identity document ")
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Accept ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Reject ")
const _hoisted_21 = {
  key: 1,
  class: "col-span-full flex flex-row h-[100px] bg-grey100 items-center justify-center rounded-md"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("No document found")
const _hoisted_23 = { class: "w-full flex flex-col space-y-3" }
const _hoisted_24 = { class: "w-full flex flex-row items-start justify-start" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Provider Verification Documents")
const _hoisted_26 = { class: "w-full grid mdlg:!grid-cols-4 gap-5 md:grid-cols-2 grid-cols-1" }
const _hoisted_27 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_28 = ["href"]
const _hoisted_29 = {
  key: 1,
  class: "col-span-full flex flex-row h-[100px] bg-grey100 items-center justify-center rounded-md"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode("No document found")
const _hoisted_31 = { class: "w-full flex flex-col space-y-3" }
const _hoisted_32 = { class: "w-full flex flex-row items-start justify-start" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Provider Bookings")
const _hoisted_34 = { class: "w-full flex flex-col rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_35 = { class: "w-full flex flex-col space-y-3" }
const _hoisted_36 = { class: "w-full flex flex-row items-start justify-start" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Provider Activities")
const _hoisted_38 = { class: "w-full flex flex-col rounded-md border-[1px] border-grey300 px-4 py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_icon = _resolveComponent("roof-icon")!
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_button = _resolveComponent("roof-button")!
  const _component_roof_page_data = _resolveComponent("roof-page-data")!
  const _component_roof_normal_text = _resolveComponent("roof-normal-text")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "w-[38px] h-[38px] cursor-pointer rounded-full border-[1px] border-gray-grey300 flex flex-row items-center justify-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Logic.Common.goBack()))
        }, [
          _createVNode(_component_roof_icon, {
            customClass: 'h-[20px]',
            name: 'chevron-left'
          })
        ]),
        _createVNode(_component_roof_header_text, { "custom-class": '!text-2xl' }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_roof_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddTransaction(_ctx.EachProvider.uuid, 'user')))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_roof_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateProviderAccountType()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Change to " + _toDisplayString(_ctx.EachProvider.profile?.provider?.account_type == 'individual'
              ? 'Business'
              : 'Individual'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_roof_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeToClient()))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_roof_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showUpdateVerification()))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_roof_page_data, { data: _ctx.pageData }, null, 8, ["data"]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_roof_header_text, null, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.EachProvider.profile.provider.verification_image)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_roof_icon, {
                    customClass: 'h-[25px]',
                    name: 'file'
                  }),
                  _createVNode(_component_roof_normal_text, null, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("a", {
                  class: "w-[40px] h-[40px] rounded-full cursor-pointer border-[1px] border-grey300 flex flex-row items-center justify-center",
                  href: _ctx.EachProvider.profile.provider.verification_image,
                  target: "_blank"
                }, [
                  _createVNode(_component_roof_icon, {
                    customClass: 'h-[25px]',
                    name: 'download'
                  })
                ], 8, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_roof_button, {
                  "custom-class": `${
                  _ctx.EachProvider.profile?.user_verified ? 'opacity-50' : ''
                }`,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (
                  _ctx.EachProvider.profile?.user_verified
                    ? null
                    : _ctx.updateIDverification(true)
                ))
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["custom-class"]),
                _createVNode(_component_roof_button, {
                  "custom-class": `${
                  _ctx.EachProvider.profile?.user_verified ? '' : 'opacity-50'
                }`,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (
                  _ctx.EachProvider.profile?.user_verified
                    ? _ctx.updateIDverification(false)
                    : null
                ))
                }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }, 8, ["custom-class"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_roof_normal_text, null, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_roof_header_text, null, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_26, [
        (_ctx.providerDocuments.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.providerDocuments, (document, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-span-1 rounded-md border-[1px] border-grey300 px-4 py-4 flex flex-row items-center justify-between"
              }, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_roof_icon, {
                    customClass: 'h-[25px]',
                    name: 'file'
                  }),
                  _createVNode(_component_roof_normal_text, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(document.type), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("a", {
                  class: "w-[40px] h-[40px] rounded-full cursor-pointer border-[1px] border-grey300 flex flex-row items-center justify-center",
                  href: document.document,
                  target: "_blank"
                }, [
                  _createVNode(_component_roof_icon, {
                    customClass: 'h-[25px]',
                    name: 'download'
                  })
                ], 8, _hoisted_28)
              ]))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(_component_roof_normal_text, null, {
                default: _withCtx(() => [
                  _hoisted_30
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_roof_header_text, null, {
          default: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createVNode(_component_roof_table, {
          tableStructure: _ctx.Logic.Booking.BookingTableStructure,
          paginatedData: _ctx.PageBookings,
          "table-date-source": _ctx.Logic.Booking.BookingSource,
          extraQuery: _ctx.extraQuery,
          queryOptionsToHide: [2],
          "sub-page-route": '/bookings/'
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source", "extraQuery"])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_roof_header_text, null, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_roof_table, {
          tableStructure: _ctx.Logic.Admins.ActivityLogTableStructure,
          paginatedData: _ctx.PageActivities,
          "table-date-source": _ctx.Logic.Admins.ActivityLogSource,
          extraQuery: _ctx.extraQuery,
          queryOptionsToHide: [0]
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source", "extraQuery"])
      ])
    ])
  ]))
}